import { Logout01Icon } from '@hugeicons/core-free-icons'
import { HugeiconsIcon } from '@hugeicons/react'
import * as React from 'react'

import { sair, useSessao } from '@/lib/sessao'
import { cn } from '@/lib/utils'

import { Separator } from '@/components/ui/separator'
import { ThemeToggle } from '@/components/ui/theme-toggle'
import {
  UserMenu,
  UserMenuAvatar,
  UserMenuContent,
  UserMenuItem,
  UserMenuSeparator,
  UserMenuTrigger,
} from '@/components/ui/user-menu'

/** True em telas de celular (até 639 px), para o botão da conta virar só o avatar. */
function useTelaPequena(): boolean {
  const [pequena, setPequena] = React.useState(false)
  React.useEffect(() => {
    const media = window.matchMedia('(max-width: 639px)')
    const aoMudar = () => setPequena(media.matches)
    aoMudar()
    media.addEventListener('change', aoMudar)
    return () => media.removeEventListener('change', aoMudar)
  }, [])
  return pequena
}

/** Canto direito do topo: tema claro/escuro e menu da conta, com "Sair". */
export function AcoesTopo() {
  const { name, email } = useSessao()
  const telaPequena = useTelaPequena()
  const usuario = { name: name || email, email }

  return (
    <div className="flex items-center gap-2">
      <ThemeToggle variant="outline" className="size-9 rounded-full" />
      <Separator orientation="vertical" className="h-5 shrink-0 self-center" />
      <UserMenu>
        <UserMenuTrigger
          user={usuario}
          showName={!telaPequena}
          density="compact"
          variant="outline"
          aria-label={`Conta de ${usuario.name}`}
          className={cn(
            telaPequena ? 'size-9 rounded-full' : 'h-9 max-w-[16rem] rounded-full pr-2.5 pl-1'
          )}
        />
        {/* Fundo cheio: o vidro translúcido deixava o conteúdo da página aparecer por trás. */}
        <UserMenuContent align="end" className="bg-popover shadow-lg">
          <div className="flex items-center gap-2.5 px-2 py-2">
            <UserMenuAvatar user={usuario} size="default" />
            <div className="flex min-w-0 flex-1 flex-col">
              <span className="truncate text-sm font-medium">{usuario.name}</span>
              <a
                href={`mailto:${email}`}
                className="truncate text-xs text-muted-foreground underline-offset-4 hover:underline"
              >
                {email}
              </a>
            </div>
          </div>
          <UserMenuSeparator />
          <UserMenuItem onClick={() => void sair()}>
            <HugeiconsIcon icon={Logout01Icon} strokeWidth={2} />
            Sair
          </UserMenuItem>
        </UserMenuContent>
      </UserMenu>
    </div>
  )
}
